import {
  ManualAddressInputsContainer,
  ManualAddressInput,
  ToggleText,
  StreetAddressInput,
} from './ManualAddressInputs.styled';
import { ToggleAddressInputStyleButton } from '../../pages/InputPage/InputPage.styled';

const ManualAddressInputs = ({
  addressData,
  toggleAddressInputStyle,
  onAddressChange,
}) => {
  const handleAddressInputChange = (fieldKey, fieldValue) => {
    if (onAddressChange) {
      onAddressChange(fieldKey, fieldValue);
    }
  };

  return (
    <ManualAddressInputsContainer>
      <StreetAddressInput
        type="text"
        placeholder="Street Address"
        value={addressData?.streetAddress || ''}
        onChange={(e) =>
          handleAddressInputChange('streetAddress', e.target.value)
        }
      />
      <ManualAddressInput
        type="text"
        placeholder="City"
        value={addressData?.city || ''}
        onChange={(e) => handleAddressInputChange('city', e.target.value)}
      />
      <ManualAddressInput
        type="text"
        placeholder="ZIP Code"
        value={addressData?.zip || ''}
        onChange={(e) => handleAddressInputChange('zip', e.target.value)}
      />
      <ToggleText>
        To use the address lookup{' '}
        <ToggleAddressInputStyleButton
          onClick={() => toggleAddressInputStyle()}
        >
          click here
        </ToggleAddressInputStyleButton>
      </ToggleText>
    </ManualAddressInputsContainer>
  );
};

export default ManualAddressInputs;
